// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".SettingsPane {\n  height: 100%;\n  overflow: auto;\n}\n", "",{"version":3,"sources":["/apps/proksee/project/releases/20250624162016/app/javascript/proksee-viewer/panes/SettingsPane.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;AAChB","file":"SettingsPane.css","sourcesContent":[".SettingsPane {\n  height: 100%;\n  overflow: auto;\n}\n"]}]);
// Exports
module.exports = exports;
